import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCompressJpgConfig } from '@/data/landingConfig/landingCompressJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CompressJpg } from './schemaObject';

interface Props {}
const CompressJpg: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CompressJpg} />
			<LandingTemplate
				data={landingCompressJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default CompressJpg;
